module.exports = __webpack_public_path__ + "img/instagram.aacb6ca4.png";